import { LinkingOptions } from '@react-navigation/native';

export type RootParamList = {
  CompanyStartScreen: undefined;
  CompanyLandingScreen: undefined;
  CompanyDetailsScreen: { isEditing: boolean };
  CompanyAddressScreen: undefined;

  VehiclesEditScreen: undefined;

  VehicleStartScreen: { id?: number };
  VehicleAddScreen: undefined;
  VehicleEditScreen: { id?: number };
  VehicleBypassScreen: undefined;

  DriverStartScreen: { id?: number };
  DriverAddScreen: undefined;
  DriverEditScreen: { id?: number };
  DriverBypassScreen: undefined;

  QuoteScreen: undefined;
  QuoteSuccessScreen: undefined;

  AddFreightScreen: undefined;

  PolicyScreen: undefined;
  InsuranceScreen: undefined;
  RiskHistoryScreen: undefined;
  GrowthAndOwnershipScreen: undefined;
  LossScreen: undefined;
  ConfirmationScreen: undefined;

  FollowupScreen: { redirectUrl: string }; // Add FollowupScreen with redirectUrl parameter
};

// Define linking configuration
export const linking: LinkingOptions<RootParamList> = {
  prefixes: ['http://localhost:3000'],
  config: {
    screens: {
      CompanyStartScreen: '',
      CompanyLandingScreen: 'company-landing',
      CompanyDetailsScreen: 'company-details',
      CompanyAddressScreen: 'company-address',

      VehicleStartScreen: 'vehicle/:id?',
      VehicleEditScreen: 'vehicle-edit/:id?',
      VehicleAddScreen: 'vehicle-add',
      VehicleBypassScreen: 'vehicle-bypass',

      DriverStartScreen: 'driver-license/:id?',
      DriverEditScreen: 'driver-edit/:id?',
      DriverAddScreen: 'driver-add',
      DriverBypassScreen: '/driver-bypass',

      InsuranceScreen: 'insurance',
      PolicyScreen: 'policy',
      RiskHistoryScreen: 'risk-history',
      GrowthAndOwnershipScreen: 'growth-and-ownership',
      LossScreen: 'loss',
      ConfirmationScreen: 'confirm',

      QuoteScreen: 'quote',
      QuoteSuccessScreen: 'quote-success',

      AddFreightScreen: 'add-freight',

      FollowupScreen: 'followup-screen', // Add FollowupScreen route
    },
  },
};
